import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Chip,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { CopyWorkerStatsToClipboardButton } from "components/manageLabellers/copyStatsToClipboardButton";
import { QuickFilterKey } from "components/users/userAdminFilters";
import { useTenantTranslation } from "hooks/formatters";
import { CsvColumnDef } from "src/utils/csv";

const QUICK_FILTER_KEYS: readonly QuickFilterKey[] = [
  "admins",
  "disabled",
  "noPermissions",
];

export const UserFilterBar = <T,>({
  search,
  onSearchChange,
  searchPlaceholder,
  quickFilters,
  exportRows,
  exportColumns,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  quickFilters?: {
    active: ReadonlySet<QuickFilterKey>;
    onToggle: (key: QuickFilterKey) => void;
  };
  exportRows: T[];
  exportColumns: CsvColumnDef<T>[];
}) => {
  const { t } = useTenantTranslation();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ flexWrap: "wrap" }}
    >
      <TextField
        size="small"
        value={search}
        onChange={(event) => {
          onSearchChange(event.target.value);
        }}
        placeholder={searchPlaceholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          },
        }}
        sx={{ minWidth: 260 }}
      />
      {quickFilters ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            {t("filter")}
          </Typography>
          {QUICK_FILTER_KEYS.map((key) => {
            const isActive = quickFilters.active.has(key);
            return (
              <Chip
                key={key}
                size="small"
                label={t(key)}
                color={isActive ? "primary" : "default"}
                variant={isActive ? "filled" : "outlined"}
                onClick={() => {
                  quickFilters.onToggle(key);
                }}
              />
            );
          })}
        </Stack>
      ) : null}
      <Box sx={{ marginLeft: "auto" }}>
        <CopyWorkerStatsToClipboardButton
          rows={exportRows}
          columns={exportColumns}
        />
      </Box>
    </Stack>
  );
};
